// import MUI - React
import {
    Box,
    Typography,
    Checkbox,
} from "@mui/material";
// Import Component
import ListaOrdini from "./ListaOrdini";
import { useTranslation } from "react-i18next";
import { areAllCheckoutRowsSelected } from "../utils/checkoutSelection";

const RiepilogoComanda = ({
    selectedTable,
    ordiniDivisi,
    ordiniFiltrati,
    ordineSchermo,
    ordiniUniti,
    checkboxSelectedIds,
    handleCheck,
    adjustmentItems = [],
}) => {

    const { t } = useTranslation();
    const getSelectionKey = (row) => (
        ordiniDivisi
            ? row.idSplit
            : row.isFixedPriceMenu
                ? `fixed-menu:${row.id}`
                : row.isPackage
                    ? `pkg:${row.id}`
                    : `prd:${row.id}`
    );

    function sameValues(a, b) {
        return areAllCheckoutRowsSelected(a, b, getSelectionKey);
    }
    
    return (
        <Box sx={{ height: "100%", minHeight: 0, display: "flex", flexDirection: "column", flex: 1 }}>
            <Box display={"flex"} justifyContent={"space-between"}>
                <Typography sx={{ margin: 1 }}>{t("client_page.order").toUpperCase()}</Typography>
                {(ordiniFiltrati?.length > 0 && selectedTable) &&
                    <Checkbox
                        checked={ordiniDivisi ? sameValues(checkboxSelectedIds, ordineSchermo) : sameValues(checkboxSelectedIds, ordiniUniti)}
                        onChange={() => handleCheck("all")}
                        onMouseDown={(e) => e.preventDefault()}
                    />
                }
            </Box>
            <Box
                id="SCROLL_CONTAINER"
                sx={{
                    flex: 1,
                    minHeight: { xs: 170, md: 210, lg: 0 },
                    maxHeight: "none",
                    overflowY: "hidden",
                    pr: 0.5,
                }}>
                <ListaOrdini
                    ordiniDivisi={ordiniDivisi}
                    selectedTable={selectedTable}
                    ordineSchermo={ordineSchermo}
                    ordiniUniti={ordiniUniti}
                    checkboxSelectedIds={checkboxSelectedIds}
                    onCheck={handleCheck}
                    adjustmentItems={adjustmentItems}
                />
            </Box>
        </Box>
    )
}
export default RiepilogoComanda;
